export enum TimeOffView {
    Calendar,
    Table
}
